module.exports = __webpack_public_path__ + "media/application/images/company/founders/Colin-Joudrie-6470a37e14265e4c00a6ab949aa298c9.jpg";